import { DocumentData } from 'firebase/firestore';
import { useReducer } from 'react';

import { Action, SET_CONTRACT_NUMBER, SET_SIGNED_CONTRACT } from './actions';
import { stateReducer } from './stateReducer';
import { CreateContractState } from './types';

export const DEFAULT_STATE: CreateContractState = {
  contractData: {
    contractDownloadUrl: '',
    contractNumber: '',
    signedContract: new Uint8Array(),
  },
};

interface UseStateManagerOptions {
  onboardingData?: DocumentData | null;
}

export type UseStateManagerReturn = {
  setContractNumber: (contractNumber: string) => void;
  setSignedContract: (signedContract: Uint8Array) => void;
  state: CreateContractState;
};

export const useStateManager = ({ onboardingData }: UseStateManagerOptions): UseStateManagerReturn => {
  const onboardingContractData = onboardingData?.contract;

  const [state, dispatch] = useReducer<CreateContractState, [Action]>(stateReducer, {
    contractData: {
      ...DEFAULT_STATE.contractData,
      ...onboardingContractData,
    },
  });

  const setContractNumber = (contractNumber: string): void => {
    dispatch({ payload: { contractNumber }, type: SET_CONTRACT_NUMBER.type });
  };

  const setSignedContract = (signedContract: Uint8Array): void => {
    dispatch({ payload: { signedContract }, type: SET_SIGNED_CONTRACT.type });
  };

  return { setContractNumber, setSignedContract, state };
};
